export default function SvgUserCheck(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M10.5 12.917H6.75c-1.164 0-1.745 0-2.218.143a3.333 3.333 0 00-2.222 2.222c-.144.473-.144 1.055-.144 2.218M13.833 15l1.666 1.667 3.334-3.334m-6.25-7.083a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
      ></path>
    </svg>
  )
}
